import { Avatar, Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ItemDisplayInfoCard = ({ info }) => {
  const { t } = useTranslation();

  return (
    <Box paddingTop={2}>
      <Box>
        <Typography gutterBottom variant="h5" mb={1}>
          {t('page.products.items.displayInfo.title')}
        </Typography>
        <Typography gutterBottom data-testid={`Language${info.langCode}Title`}>
          {info.title}
        </Typography>
      </Box>
      <Box mt={3}>
        <Typography gutterBottom variant="h5" mb={1}>
          {t('page.products.items.displayInfo.shortDescription')}
        </Typography>
        <Typography
          data-testid={`Language${info.langCode}ShortDescription`}
          gutterBottom
          sx={{
            fontStyle: !info.shortDescription ? 'italic' : 'normal',
          }}
        >
          {info.shortDescription ||
            t('page.products.items.displayInfo.noAvailableData')}
        </Typography>
      </Box>
      <Box mt={3}>
        <Typography gutterBottom variant="h5" mb={1}>
          {t('page.products.items.displayInfo.longDescription')}
        </Typography>
        <Typography
          data-testid={`Language${info.langCode}LongDescription`}
          gutterBottom
          sx={{
            fontStyle: !info.longDescription ? 'italic' : 'normal',
          }}
        >
          {info.longDescription ||
            t('page.products.items.displayInfo.noAvailableData')}
        </Typography>
      </Box>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <Box textAlign="left">
            <Typography gutterBottom variant="h5" mb={2}>
              {t('page.products.items.displayInfo.smallImage')}
            </Typography>
            {info?.smallImage?.length > 0 ? (
              <Avatar
                alt=""
                src={info?.smallImage?.[0]}
                variant="square"
                data-testid={'SmallItemDetailImage'}
                sx={{ width: 50, height: 50 }}
              />
            ) : (
              <Typography
                data-testid={`SmallImageNoAvailable${info.langCode}`}
                gutterBottom
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                }}
              >
                {t('page.products.items.displayInfo.noAvailableImage')}
              </Typography>
            )}
          </Box>
        </Grid>

        <Grid size={{ xs: 12, sm: 9 }}>
          <Box textAlign="left">
            <Typography gutterBottom variant="h5" mb={2}>
              {t('page.products.items.displayInfo.mediumImage')}
            </Typography>
            {info?.mediumImage?.length > 0 ? (
              <Avatar
                alt=""
                src={info.mediumImage?.[0]}
                variant="square"
                data-testid={'MediumItemDetailImage'}
                sx={{ width: 100, height: 100 }}
              />
            ) : (
              <Typography
                data-testid={`MediumImageNoAvailable${info.langCode}`}
                gutterBottom
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                }}
              >
                {t('page.products.items.displayInfo.noAvailableImage')}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default ItemDisplayInfoCard;
